import { api } from '@services';

import qs from 'query-string';

import Product, {
  IProductCreateUpdate,
  IProductCreateUpdateApiModel,
} from '@models/Product.model';
import { IPaginationResult } from '@models/Equipment.model';

interface IRequest {
  search: string;
  limit: number;
  page: number;
  manufacturerId?: string | null;
}

const getProductsCreateUpdate = async ({
  limit = 20,
  page,
  search,
  manufacturerId,
}: IRequest): Promise<IPaginationResult<IProductCreateUpdate>> => {
  const query = {
    limit,
    page,
    q: search,
    manufacturerId,
  };

  const queryString = qs.stringify(query);
  const { data: products } = await api.get<
    IPaginationResult<IProductCreateUpdateApiModel>
  >(`/products/createUpdate?${queryString}`);

  return Product.arrayPaginatedFromCreateUpdateApiModel(products);
};

export { getProductsCreateUpdate };
